import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Products
export const listProducts = (activeOnly = false) => api.get("/products", { params: activeOnly ? { active_only: true } : {} }).then(r => r.data);
export const getProduct = (id) => api.get(`/products/${id}`).then(r => r.data);
export const createProduct = (data) => api.post("/products", data).then(r => r.data);
export const updateProduct = (id, data) => api.patch(`/products/${id}`, data).then(r => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then(r => r.data);

// Payments
export const createCheckout = (data) => api.post("/payments/checkout/session", data).then(r => r.data);
export const getCheckoutStatus = (session_id) => api.get(`/payments/checkout/status/${session_id}`).then(r => r.data);
export const listTransactions = () => api.get("/payments/transactions").then(r => r.data);

// AI Image gen
export const generateProductImage = (product_id, prompt = "") =>
  api.post(`/products/${product_id}/generate-image`, { prompt }, { timeout: 120000 }).then(r => r.data);

// AI Marketing Kit (Pinterest 2:3, IG 1:1, TikTok 9:16)
export const generateMarketingKit = (product_id) =>
  api.post(`/products/${product_id}/generate-marketing-kit`, {}, { timeout: 240000 }).then(r => r.data);

// Analytics
export const trackView = (product_id, referrer = "", utm_source = "") =>
  api.post("/analytics/view", { product_id, referrer, utm_source }, { withCredentials: false }).then(r => r.data);
export const getProductAnalytics = () => api.get("/analytics/products").then(r => r.data);

// Sellvia importer
export const importFromSellvia = (sellvia_url, markup_percentage = 100, auto_marketing = false) =>
  api.post("/products/import-from-sellvia", { sellvia_url, markup_percentage, auto_marketing }, { timeout: 60000 }).then(r => r.data);
export const scrapeSellviaBlog = (blog_url) =>
  api.post("/products/scrape-blog", { blog_url }, { timeout: 180000 }).then(r => r.data);
export const bulkImportFromSellvia = (product_urls, markup_percentage = 100, auto_marketing = false, candidates = []) =>
  api.post("/products/bulk-import-from-sellvia", { product_urls, markup_percentage, auto_marketing, candidates }, { timeout: 300000 }).then(r => r.data);

// Settings
export const getSettings = () => api.get("/settings").then(r => r.data);
export const saveSettings = (data) => api.post("/settings", data).then(r => r.data);

// Orders
export const listOrders = (status) => api.get("/orders", { params: status ? { status } : {} }).then(r => r.data);
export const createOrder = (data) => api.post("/orders", data).then(r => r.data);
export const updateOrder = (id, data) => api.patch(`/orders/${id}`, data).then(r => r.data);
export const deleteOrder = (id) => api.delete(`/orders/${id}`).then(r => r.data);
export const importOrdersCsv = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/orders/import`, fd, { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true }).then(r => r.data);
};

// Stats
export const getStats = () => api.get("/stats").then(r => r.data);

// Ads
export const generateAds = (data) => api.post("/ads/generate", data, { timeout: 60000 }).then(r => r.data);
export const listAds = () => api.get("/ads").then(r => r.data);
export const deleteAd = (id) => api.delete(`/ads/${id}`).then(r => r.data);

// FAQs
export const listFaqs = () => api.get("/faqs").then(r => r.data);
export const createFaq = (data) => api.post("/faqs", data).then(r => r.data);
export const deleteFaq = (id) => api.delete(`/faqs/${id}`).then(r => r.data);

// Chat
export const sendChat = (session_id, message, customer_name = "Guest") =>
  api.post("/chat/message", { session_id, message, customer_name }, { timeout: 60000 }).then(r => r.data);
export const listChatSessions = () => api.get("/chat/sessions").then(r => r.data);
export const getChatMessages = (session_id) => api.get(`/chat/sessions/${session_id}/messages`).then(r => r.data);
export const deleteChatSession = (session_id) => api.delete(`/chat/sessions/${session_id}`).then(r => r.data);
